// Manually editing this file is discouraged. It was generated with:
// $ oso-cloud generate-types typescript polar/adCreative.polar polar/admin.polar polar/adminBlockedEmails.polar polar/optimizeNonHostedSite.polar polar/optimizeNonHostedSiteApp.polar polar/optimizeNonHostedSiteData.polar polar/permissionOverrideRules.polar polar/site.polar polar/siteAI.polar polar/siteAccessRules.polar polar/siteActivityLog.polar polar/siteAeoAnalytics.polar polar/siteAeoBrand.polar polar/siteAeoLLMConfig.polar polar/siteAeoRecommendations.polar polar/siteAgentInstructions.polar polar/siteAgenticWorkflows.polar polar/siteAnalyzeAddon.polar polar/siteAnnotation.polar polar/siteApiClientToken.polar polar/siteApp.polar polar/siteBilling.polar polar/siteBranch.polar polar/siteCampaign.polar polar/siteClient.polar polar/siteCollection.polar polar/siteCollectionItem.polar polar/siteCommerce.polar polar/siteCommerceDrivers.polar polar/siteCommerceItem.polar polar/siteCosmic.polar polar/siteCustomCode.polar polar/siteCustomDomain.polar polar/siteDesignerModes.polar polar/siteFile.polar polar/siteFlow.polar polar/siteForm.polar polar/siteLibrary.polar polar/siteLink.polar polar/siteLocale.polar polar/siteMembership.polar polar/siteMeta.polar polar/siteOptimizeAddon.polar polar/siteOptimizeAnalyzeMetricEvent.polar polar/siteOptimizeAudienceEventMetric.polar polar/siteOptimizeExperience.polar polar/siteOptimizeIntegrations.polar polar/siteOptimizeResults.polar polar/siteOptimizeVariation.polar polar/siteOptimizeVariationState.polar polar/sitePage.polar polar/sitePageSettings.polar polar/siteProfile.polar polar/siteRedirects.polar polar/siteReport.polar polar/siteRole.polar polar/siteSearch.polar polar/siteSecret.polar polar/siteSnapshot.polar polar/siteStyleBlock.polar polar/siteSymbol.polar polar/siteTrackingSettings.polar polar/siteUserSystems.polar polar/siteVariable.polar polar/siteWebhook.polar polar/user.polar polar/workspace.polar polar/workspaceApp.polar polar/workspaceAsset.polar polar/workspaceAuditLog.polar polar/workspaceBilling.polar polar/workspaceClient.polar polar/workspaceFolder.polar polar/workspaceIntegration.polar polar/workspaceInvite.polar polar/workspaceLibrary.polar polar/workspaceMembership.polar polar/workspaceOptimizeNonHostedSite.polar polar/workspacePartnerCommissions.polar polar/workspacePartnerProgram.polar polar/workspacePartnerResourceGroup.polar polar/workspacePartnerResources.polar polar/workspacePartnerTermsOfService.polar polar/workspaceProfile.polar polar/workspaceSite.polar polar/workspaceSiteRoles.polar polar/workspaceToken.polar
export const PolarResources = {
  "AdCreative": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "siteCampaign": "SiteCampaign",
    },
  },
  "Admin": {
    roles: [
      "ADMIN",
      "EDITOR",
      "VIEWER",
    ],
    permissions: [
      "delete",
      "manage",
      "read",
    ],
    relations: {},
  },
  "AdminBlockedEmails": {
    roles: [
      "apps-webflow.admin.blocked-emails.admin",
      "apps-webflow.admin.blocked-emails.editor",
      "apps-webflow.admin.blocked-emails.viewer",
      "apps-webflow.admin.super-admin",
    ],
    permissions: [
      "manage",
      "read",
    ],
    relations: {},
  },
  "OptimizeNonHostedSite": {
    roles: [
      "administrator",
      "designer",
      "landing-page-designer",
      "publisher",
      "viewer",
    ],
    permissions: [],
    relations: {
      "workspace": "Workspace",
    },
  },
  "OptimizeNonHostedSiteApp": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "nonHostedSite": "OptimizeNonHostedSite",
    },
  },
  "OptimizeNonHostedSiteData": {
    roles: [],
    permissions: [
      "delete",
      "manage",
      "read",
    ],
    relations: {
      "nonHostedSite": "OptimizeNonHostedSite",
    },
  },
  "Site": {
    roles: [
      "branch_designer",
      "commenter",
      "designer",
      "editor",
      "page_builder",
      "page_builder_v2",
      "project_admin",
      "public",
      "viewer",
    ],
    permissions: [
      "approve",
      "delete",
      "design",
      "duplicate",
      "export",
      "publish",
      "read",
      "share",
      "simulateRoles",
      "subPublish",
      "transfer",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "SiteAI": {
    roles: [],
    permissions: [
      "use",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteActivityLog": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAeoAnalytics": {
    roles: [],
    permissions: [
      "manage",
      "view",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAeoBrand": {
    roles: [],
    permissions: [
      "manage",
      "view",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAeoLLMConfig": {
    roles: [],
    permissions: [
      "manage",
      "view",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAeoRecommendations": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAgentInstructions": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAgenticWorkflows": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAnalyzeAddon": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteAnnotation": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteApiClientToken": {
    roles: [],
    permissions: [
      "create",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteApp": {
    roles: [],
    permissions: [
      "install",
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteBilling": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteBranch": {
    roles: [],
    permissions: [
      "createFromTemplate",
      "createStandalone",
      "design",
      "editContent",
      "manage",
      "merge",
      "mergeApproved",
      "publish",
    ],
    relations: {
      "locale": "SiteLocale",
      "parent": "SitePage",
      "scope": "SiteBranchScope",
      "site": "Site",
    },
  },
  "SiteBranchScope": {
    roles: [],
    permissions: [
      "identify",
    ],
    relations: {},
  },
  "SiteCampaign": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteClient": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCollection": {
    roles: [],
    permissions: [
      "create_items",
      "manage",
      "read",
    ],
    relations: {
      "locale": "SiteLocale",
      "site": "Site",
    },
  },
  "SiteCollectionItem": {
    roles: [],
    permissions: [
      "manage",
      "publish",
      "queue",
      "read",
    ],
    relations: {
      "collection": "SiteCollection",
      "locale": "SiteLocale",
    },
  },
  "SiteCommerce": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCommerceDrivers": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCommerceItem": {
    roles: [],
    permissions: [
      "manage",
      "publish",
      "queue",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCosmic": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCustomCode": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteCustomDomain": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteDesignerModes": {
    roles: [],
    permissions: [
      "design",
      "edit",
      "view",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteFile": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteFlow": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteForm": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteLibrary": {
    roles: [],
    permissions: [
      "addComponent",
      "manage",
      "share",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteLink": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteLocale": {
    roles: [],
    permissions: [
      "editContent",
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteMembership": {
    roles: [],
    permissions: [
      "read",
      "update",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteMeta": {
    roles: [],
    permissions: [
      "accessAPI",
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeAddon": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeAnalyzeMetricEvent": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeAudienceEventMetric": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeExperience": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeIntegrations": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeResults": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeVariation": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteOptimizeVariationState": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SitePage": {
    roles: [],
    permissions: [
      "build",
      "create",
      "createBranch",
      "createFromTemplate",
      "duplicate",
      "editContent",
      "editContentInBranch",
      "manageTemplates",
      "modify",
      "sppPublishToProduction",
      "sppPublishToStaging",
    ],
    relations: {
      "branch": "SiteBranch",
      "locale": "SiteLocale",
      "origin": "SitePage",
      "site": "Site",
    },
  },
  "SitePageSettings": {
    roles: [],
    permissions: [
      "manage",
      "manageTemplates",
      "read",
    ],
    relations: {
      "locale": "SiteLocale",
      "page": "SitePage",
      "site": "Site",
    },
  },
  "SiteProfile": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteRedirects": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteReport": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteRole": {
    roles: [],
    permissions: [],
    relations: {},
  },
  "SiteSearch": {
    roles: [],
    permissions: [
      "index",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteSecret": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteSnapshot": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteStyleBlock": {
    roles: [],
    permissions: [
      "create",
      "modify",
      "modifyOwn",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteSymbol": {
    roles: [],
    permissions: [
      "create",
      "manage",
      "modify",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteTrackingSettings": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteUserSystems": {
    roles: [],
    permissions: [
      "manage",
      "manageGroups",
      "read",
      "readGroups",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteVariable": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "SiteWebhook": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "site": "Site",
    },
  },
  "User": {
    roles: [],
    permissions: [],
    relations: {},
  },
  "Workspace": {
    roles: [
      "admin",
      "client",
      "commenter",
      "guest",
      "member",
      "owner",
      "public",
    ],
    permissions: [
      "delete",
      "read",
      "readTemplates",
      "signUpload",
      "update",
    ],
    relations: {},
  },
  "WorkspaceApp": {
    roles: [],
    permissions: [
      "install",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceAsset": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceAuditLog": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceBilling": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceClient": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceFolder": {
    roles: [],
    permissions: [
      "read",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceIntegration": {
    roles: [],
    permissions: [
      "install",
      "read",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceInvite": {
    roles: [],
    permissions: [
      "create",
      "createReviewer",
      "delete",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceLibrary": {
    roles: [],
    permissions: [
      "manage",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceMembership": {
    roles: [],
    permissions: [
      "deleteOwn",
      "read",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceOptimizeNonHostedSite": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspacePartnerCommissions": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspacePartnerProgram": {
    roles: [],
    permissions: [
      "manage",
      "takeExam",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspacePartnerResourceGroup": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspacePartnerResources": {
    roles: [],
    permissions: [
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspacePartnerTermsOfService": {
    roles: [],
    permissions: [
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceProfile": {
    roles: [],
    permissions: [
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceSite": {
    roles: [],
    permissions: [
      "create",
      "manageMembership",
      "moderateComments",
      "read",
      "readAccessible",
      "readCredited",
      "readPermissions",
      "readRequiresExplicitAccess",
      "restrictAccess",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceSiteRoles": {
    roles: [],
    permissions: [
      "manage",
      "read",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
  "WorkspaceToken": {
    roles: [],
    permissions: [
      "create",
      "delete",
      "read",
      "update",
    ],
    relations: {
      "workspace": "Workspace",
    },
  },
} as const;
export type PolarTypes = {
  fact:
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "accessAPI" },
        { type: "String"; id: "SiteMeta" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "addComponent" },
        { type: "String"; id: "SiteLibrary" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "approve" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "build" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "create" },
        { type: "String"; id: "SiteApiClientToken" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "create" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "create" },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "create" },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "createBranch" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "createFromTemplate" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "createFromTemplate" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "createStandalone" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "create_items" },
        { type: "String"; id: "SiteCollection" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "delete" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "design" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "design" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "design" },
        { type: "String"; id: "SiteDesignerModes" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "duplicate" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "duplicate" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "edit" },
        { type: "String"; id: "SiteDesignerModes" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "editContent" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "editContent" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "export" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "index" },
        { type: "String"; id: "SiteSearch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "install" },
        { type: "String"; id: "SiteApp" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "AdCreative" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAeoAnalytics" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAeoBrand" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAeoLLMConfig" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAeoRecommendations" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAgenticWorkflows" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAnalyzeAddon" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteAnnotation" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteApp" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteBilling" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCampaign" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCollection" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCollectionItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCommerce" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCommerceDrivers" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCosmic" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCustomCode" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteCustomDomain" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteFile" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteFlow" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteForm" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteLibrary" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteLink" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteLocale" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteMeta" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeAddon" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeAnalyzeMetricEvent" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeAudienceEventMetric" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeExperience" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeIntegrations" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeVariation" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteOptimizeVariationState" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SitePageSettings" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteProfile" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteRedirects" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteSecret" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteSnapshot" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteTrackingSettings" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteVariable" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manage" },
        { type: "String"; id: "SiteWebhook" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manageGroups" },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manageTemplates" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "manageTemplates" },
        { type: "String"; id: "SitePageSettings" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "merge" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "mergeApproved" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "modify" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "modify" },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "modify" },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "modifyOwn" },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "publish" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "publish" },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "publish" },
        { type: "String"; id: "SiteCollectionItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "publish" },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "queue" },
        { type: "String"; id: "SiteCollectionItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "queue" },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "AdCreative" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteActivityLog" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteAeoRecommendations" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteAgenticWorkflows" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteAnnotation" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteBilling" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCampaign" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteClient" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCollection" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCollectionItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCommerce" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCommerceDrivers" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCosmic" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCustomCode" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteCustomDomain" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteForm" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteLocale" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteMembership" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteMeta" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteOptimizeIntegrations" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteOptimizeResults" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SitePageSettings" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteRedirects" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteReport" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteSnapshot" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteTrackingSettings" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "read" },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "readGroups" },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "share" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "share" },
        { type: "String"; id: "SiteLibrary" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "simulateRoles" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "sppPublishToProduction" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "sppPublishToStaging" },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "subPublish" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "transfer" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "update" },
        { type: "String"; id: "Site" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "update" },
        { type: "String"; id: "SiteMembership" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "use" },
        { type: "String"; id: "SiteAI" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "view" },
        { type: "String"; id: "SiteAeoAnalytics" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "view" },
        { type: "String"; id: "SiteAeoBrand" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "view" },
        { type: "String"; id: "SiteAeoLLMConfig" },
      ]
    | [
        "grants_permission",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "view" },
        { type: "String"; id: "SiteDesignerModes" },
      ]
    | [
        "has_admin_role",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "ADMIN" }
          | { type: "String"; id: "EDITOR" }
          | { type: "String"; id: "VIEWER" }
          | { type: "String"; id: "apps-webflow.admin.blocked-emails.admin" }
          | { type: "String"; id: "apps-webflow.admin.blocked-emails.editor" }
          | { type: "String"; id: "apps-webflow.admin.blocked-emails.viewer" }
          | { type: "String"; id: "apps-webflow.admin.super-admin" }
        ),
      ]
    | [
        "has_default_site_role",
        { type: "User"; id: string },
        { type: "SiteRole"; id: string },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_default_site_role",
        { type: "User"; id: string },
        { type: "String"; id: string },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteBranch"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCollection"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCollectionItem"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePageSettings"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "editContent" },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteSnapshot"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readRequiresExplicitAccess" }
        ),
        { type: "WorkspaceSite"; id: string },
      ]
    | [
        "has_relation",
        { type: "AdCreative"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "AdCreative"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "AdCreative"; id: string },
        { type: "String"; id: "siteCampaign" },
        { type: "SiteCampaign"; id: string },
      ]
    | [
        "has_relation",
        { type: "Admin"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "Admin"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "AdminBlockedEmails"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "AdminBlockedEmails"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSite"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSite"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSite"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteApp"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteApp"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteApp"; id: string },
        { type: "String"; id: "nonHostedSite" },
        { type: "OptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteData"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteData"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "OptimizeNonHostedSiteData"; id: string },
        { type: "String"; id: "nonHostedSite" },
        { type: "OptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_relation",
        { type: "Site"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "Site"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "Site"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAI"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAI"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAI"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteActivityLog"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteActivityLog"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteActivityLog"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoAnalytics"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoAnalytics"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoAnalytics"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoBrand"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoBrand"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoBrand"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoRecommendations"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoRecommendations"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAeoRecommendations"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgentInstructions"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgentInstructions"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgentInstructions"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnnotation"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnnotation"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteAnnotation"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApiClientToken"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApiClientToken"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApiClientToken"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApp"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApp"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteApp"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBilling"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBilling"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBilling"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "parent" },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranchScope"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranchScope"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCampaign"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCampaign"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCampaign"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteClient"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteClient"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteClient"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollection"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollection"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollection"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollectionItem"; id: string },
        { type: "String"; id: "collection" },
        { type: "SiteCollection"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollectionItem"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCollectionItem"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerce"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerce"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerce"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceDrivers"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceDrivers"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceDrivers"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceItem"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceItem"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCommerceItem"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCosmic"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCosmic"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCosmic"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomCode"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomCode"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomCode"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomDomain"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomDomain"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteCustomDomain"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteDesignerModes"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteDesignerModes"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteDesignerModes"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFile"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFile"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFile"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFlow"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFlow"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteFlow"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteForm"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteForm"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteForm"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLibrary"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLibrary"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLibrary"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLink"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLink"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLink"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLocale"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLocale"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteLocale"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMembership"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMembership"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMembership"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMeta"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMeta"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteMeta"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAddon"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAddon"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAddon"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeExperience"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeExperience"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeExperience"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeResults"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeResults"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeResults"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariation"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariation"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariation"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePage"; id: string },
        { type: "String"; id: "branch" },
        { type: "SiteBranch"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePage"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePage"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePage"; id: string },
        { type: "String"; id: "origin" },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePage"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "page" },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_relation",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteProfile"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteProfile"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteProfile"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteRedirects"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteRedirects"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteRedirects"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteReport"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteReport"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteReport"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteRole"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSearch"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSearch"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSearch"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSecret"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSecret"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSecret"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSnapshot"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSnapshot"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSnapshot"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteStyleBlock"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteStyleBlock"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteStyleBlock"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSymbol"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSymbol"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteSymbol"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteTrackingSettings"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteTrackingSettings"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteTrackingSettings"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteUserSystems"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteUserSystems"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteUserSystems"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteVariable"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteVariable"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteVariable"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteWebhook"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteWebhook"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteWebhook"; id: string },
        { type: "String"; id: "site" },
        { type: "Site"; id: string },
      ]
    | [
        "has_relation",
        { type: "User"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "User"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "Workspace"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "Workspace"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceApp"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceApp"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceApp"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAsset"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAsset"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAsset"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAuditLog"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAuditLog"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceAuditLog"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceBilling"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceBilling"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceBilling"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceClient"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceClient"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceClient"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceFolder"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceFolder"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceFolder"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceIntegration"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceIntegration"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceIntegration"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceInvite"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceInvite"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceInvite"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceLibrary"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceLibrary"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceLibrary"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceMembership"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceMembership"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceMembership"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerCommissions"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerCommissions"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerCommissions"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerProgram"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerProgram"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerProgram"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResourceGroup"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResourceGroup"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResourceGroup"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResources"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResources"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerResources"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerTermsOfService"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerTermsOfService"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspacePartnerTermsOfService"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceProfile"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceProfile"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceProfile"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSite"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSite"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSite"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSiteRoles"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSiteRoles"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceSiteRoles"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceToken"; id: string },
        { type: "String"; id: "locale" },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceToken"; id: string },
        { type: "String"; id: "locale" },
        { type: string; id: string },
      ]
    | [
        "has_relation",
        { type: "WorkspaceToken"; id: string },
        { type: "String"; id: "workspace" },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "scope" },
        { type: "SiteBranchScope"; id: "page" },
      ]
    | [
        "has_relation",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "scope" },
        { type: "SiteBranchScope"; id: "site" },
      ]
    | [
        "has_restriction",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCollection"; id: string },
      ]
    | [
        "has_restriction",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_restriction",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_role",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "admin" }
          | { type: "String"; id: "client" }
          | { type: "String"; id: "commenter" }
          | { type: "String"; id: "guest" }
          | { type: "String"; id: "member" }
          | { type: "String"; id: "owner" }
        ),
        { type: "Workspace"; id: string },
      ]
    | [
        "has_role",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "administrator" }
          | { type: "String"; id: "designer" }
          | { type: "String"; id: "landing-page-designer" }
          | { type: "String"; id: "publisher" }
          | { type: "String"; id: "viewer" }
        ),
        { type: "OptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_role",
        { type: "User"; id: string },
        { type: "SiteRole"; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "has_role",
        { type: "User"; id: string },
        { type: "String"; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "has_role",
        { type: "User"; id: string },
        { type: string; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "is_not_empty_string",
        { type: "String"; id: string },
      ]
    | [
        "is_page_restricted",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "is_restricted",
        { type: "User"; id: string },
        { type: "SiteCollection"; id: string },
      ]
    | [
        "is_restricted",
        { type: "User"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "is_site_restricted",
        { type: "Site"; id: string },
      ]
    | [
        "permission_override",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "String"; id: string },
        { type: "String"; id: string },
        (
          | { type: "Boolean"; id: "false" }
          | { type: "Boolean"; id: "true" }
        ),
      ]
    | [
        "permission_override_allowed",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "String"; id: "publish" },
        { type: "String"; id: "Site" },
      ]
    | [
        "typeof",
        { type: "AdCreative"; id: string },
        { type: "String"; id: "AdCreative" },
      ]
    | [
        "typeof",
        { type: "Site"; id: string },
        { type: "String"; id: "Site" },
      ]
    | [
        "typeof",
        { type: "SiteAI"; id: string },
        { type: "String"; id: "SiteAI" },
      ]
    | [
        "typeof",
        { type: "SiteActivityLog"; id: string },
        { type: "String"; id: "SiteActivityLog" },
      ]
    | [
        "typeof",
        { type: "SiteAeoAnalytics"; id: string },
        { type: "String"; id: "SiteAeoAnalytics" },
      ]
    | [
        "typeof",
        { type: "SiteAeoBrand"; id: string },
        { type: "String"; id: "SiteAeoBrand" },
      ]
    | [
        "typeof",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: "String"; id: "SiteAeoLLMConfig" },
      ]
    | [
        "typeof",
        { type: "SiteAeoRecommendations"; id: string },
        { type: "String"; id: "SiteAeoRecommendations" },
      ]
    | [
        "typeof",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: "String"; id: "SiteAgenticWorkflows" },
      ]
    | [
        "typeof",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: "String"; id: "SiteAnalyzeAddon" },
      ]
    | [
        "typeof",
        { type: "SiteAnnotation"; id: string },
        { type: "String"; id: "SiteAnnotation" },
      ]
    | [
        "typeof",
        { type: "SiteApiClientToken"; id: string },
        { type: "String"; id: "SiteApiClientToken" },
      ]
    | [
        "typeof",
        { type: "SiteApp"; id: string },
        { type: "String"; id: "SiteApp" },
      ]
    | [
        "typeof",
        { type: "SiteBilling"; id: string },
        { type: "String"; id: "SiteBilling" },
      ]
    | [
        "typeof",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "typeof",
        { type: "SiteCampaign"; id: string },
        { type: "String"; id: "SiteCampaign" },
      ]
    | [
        "typeof",
        { type: "SiteClient"; id: string },
        { type: "String"; id: "SiteClient" },
      ]
    | [
        "typeof",
        { type: "SiteCommerce"; id: string },
        { type: "String"; id: "SiteCommerce" },
      ]
    | [
        "typeof",
        { type: "SiteCommerceDrivers"; id: string },
        { type: "String"; id: "SiteCommerceDrivers" },
      ]
    | [
        "typeof",
        { type: "SiteCommerceItem"; id: string },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "typeof",
        { type: "SiteCosmic"; id: string },
        { type: "String"; id: "SiteCosmic" },
      ]
    | [
        "typeof",
        { type: "SiteCustomCode"; id: string },
        { type: "String"; id: "SiteCustomCode" },
      ]
    | [
        "typeof",
        { type: "SiteCustomDomain"; id: string },
        { type: "String"; id: "SiteCustomDomain" },
      ]
    | [
        "typeof",
        { type: "SiteDesignerModes"; id: string },
        { type: "String"; id: "SiteDesignerModes" },
      ]
    | [
        "typeof",
        { type: "SiteFile"; id: string },
        { type: "String"; id: "SiteFile" },
      ]
    | [
        "typeof",
        { type: "SiteFlow"; id: string },
        { type: "String"; id: "SiteFlow" },
      ]
    | [
        "typeof",
        { type: "SiteForm"; id: string },
        { type: "String"; id: "SiteForm" },
      ]
    | [
        "typeof",
        { type: "SiteLibrary"; id: string },
        { type: "String"; id: "SiteLibrary" },
      ]
    | [
        "typeof",
        { type: "SiteLink"; id: string },
        { type: "String"; id: "SiteLink" },
      ]
    | [
        "typeof",
        { type: "SiteLocale"; id: string },
        { type: "String"; id: "SiteLocale" },
      ]
    | [
        "typeof",
        { type: "SiteMembership"; id: string },
        { type: "String"; id: "SiteMembership" },
      ]
    | [
        "typeof",
        { type: "SiteMeta"; id: string },
        { type: "String"; id: "SiteMeta" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAddon"; id: string },
        { type: "String"; id: "SiteOptimizeAddon" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: "String"; id: "SiteOptimizeAnalyzeMetricEvent" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: "String"; id: "SiteOptimizeAudienceEventMetric" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeExperience"; id: string },
        { type: "String"; id: "SiteOptimizeExperience" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: "String"; id: "SiteOptimizeIntegrations" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeResults"; id: string },
        { type: "String"; id: "SiteOptimizeResults" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariation"; id: string },
        { type: "String"; id: "SiteOptimizeVariation" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: "String"; id: "SiteOptimizeVariationState" },
      ]
    | [
        "typeof",
        { type: "SitePage"; id: string },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "typeof",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "SitePageSettings" },
      ]
    | [
        "typeof",
        { type: "SiteProfile"; id: string },
        { type: "String"; id: "SiteProfile" },
      ]
    | [
        "typeof",
        { type: "SiteRedirects"; id: string },
        { type: "String"; id: "SiteRedirects" },
      ]
    | [
        "typeof",
        { type: "SiteReport"; id: string },
        { type: "String"; id: "SiteReport" },
      ]
    | [
        "typeof",
        { type: "SiteSearch"; id: string },
        { type: "String"; id: "SiteSearch" },
      ]
    | [
        "typeof",
        { type: "SiteSecret"; id: string },
        { type: "String"; id: "SiteSecret" },
      ]
    | [
        "typeof",
        { type: "SiteSnapshot"; id: string },
        { type: "String"; id: "SiteSnapshot" },
      ]
    | [
        "typeof",
        { type: "SiteStyleBlock"; id: string },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "typeof",
        { type: "SiteSymbol"; id: string },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "typeof",
        { type: "SiteTrackingSettings"; id: string },
        { type: "String"; id: "SiteTrackingSettings" },
      ]
    | [
        "typeof",
        { type: "SiteUserSystems"; id: string },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "typeof",
        { type: "SiteVariable"; id: string },
        { type: "String"; id: "SiteVariable" },
      ]
    | [
        "typeof",
        { type: "SiteWebhook"; id: string },
        { type: "String"; id: "SiteWebhook" },
      ]
    | [
        "typeof",
        { type: "User"; id: string },
        { type: "String"; id: "User" },
      ]
    | [
        "typeof",
        { type: "AdCreative"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "Admin"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "AdminBlockedEmails"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSite"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSiteApp"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSiteData"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "Site"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAI"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteActivityLog"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAeoAnalytics"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAeoBrand"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAeoRecommendations"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAgentInstructions"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteAnnotation"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteApiClientToken"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteApp"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteBilling"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteBranch"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteBranchScope"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCampaign"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteClient"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCollection"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCollectionItem"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCommerce"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCommerceDrivers"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCommerceItem"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCosmic"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCustomCode"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteCustomDomain"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteDesignerModes"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteFile"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteFlow"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteForm"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteLibrary"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteLink"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteLocale"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteMembership"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteMeta"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAddon"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeExperience"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeResults"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariation"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SitePage"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SitePageSettings"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteProfile"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteRedirects"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteReport"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteRole"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteSearch"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteSecret"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteSnapshot"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteStyleBlock"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteSymbol"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteTrackingSettings"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteUserSystems"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteVariable"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "SiteWebhook"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "User"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "Workspace"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceApp"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceAsset"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceAuditLog"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceBilling"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceClient"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceFolder"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceIntegration"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceInvite"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceLibrary"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceMembership"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerCommissions"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerProgram"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerResourceGroup"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerResources"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerTermsOfService"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceProfile"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceSite"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceSiteRoles"; id: string },
        { type: string; id: string },
      ]
    | [
        "typeof",
        { type: "WorkspaceToken"; id: string },
        { type: string; id: string },
      ];
  query:
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "accessAPI" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteMeta"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "addComponent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "share" }
        ),
        { type: "SiteLibrary"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "approve" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "design" }
          | { type: "String"; id: "duplicate" }
          | { type: "String"; id: "export" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "share" }
          | { type: "String"; id: "simulateRoles" }
          | { type: "String"; id: "subPublish" }
          | { type: "String"; id: "transfer" }
          | { type: "String"; id: "update" }
        ),
        { type: "Site"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "build" }
          | { type: "String"; id: "create" }
          | { type: "String"; id: "createBranch" }
          | { type: "String"; id: "createFromTemplate" }
          | { type: "String"; id: "duplicate" }
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "editContentInBranch" }
          | { type: "String"; id: "manageTemplates" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "sppPublishToProduction" }
          | { type: "String"; id: "sppPublishToStaging" }
        ),
        { type: "SitePage"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "create" },
        { type: "SiteApiClientToken"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "modifyOwn" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteStyleBlock"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteSymbol"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "createReviewer" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceInvite"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "manageMembership" }
          | { type: "String"; id: "moderateComments" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readAccessible" }
          | { type: "String"; id: "readCredited" }
          | { type: "String"; id: "readPermissions" }
          | { type: "String"; id: "readRequiresExplicitAccess" }
          | { type: "String"; id: "restrictAccess" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceSite"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceToken"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "createFromTemplate" }
          | { type: "String"; id: "createStandalone" }
          | { type: "String"; id: "design" }
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "merge" }
          | { type: "String"; id: "mergeApproved" }
          | { type: "String"; id: "publish" }
        ),
        { type: "SiteBranch"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create_items" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCollection"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "Admin"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "OptimizeNonHostedSiteData"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readTemplates" }
          | { type: "String"; id: "signUpload" }
          | { type: "String"; id: "update" }
        ),
        { type: "Workspace"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "deleteOwn" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceMembership"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "design" }
          | { type: "String"; id: "edit" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteDesignerModes"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteLocale"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "index" },
        { type: "SiteSearch"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "install" }
          | { type: "String"; id: "manage" }
        ),
        { type: "SiteApp"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "install" },
        { type: "WorkspaceApp"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "install" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceIntegration"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "AdCreative"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "AdminBlockedEmails"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "OptimizeNonHostedSiteApp"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoAnalytics"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoBrand"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoLLMConfig"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAeoRecommendations"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAgentInstructions"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAgenticWorkflows"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteAnalyzeAddon"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAnnotation"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteBilling"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCampaign"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "queue" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCollectionItem"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerce"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerceDrivers"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "queue" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerceItem"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCosmic"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCustomCode"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCustomDomain"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteFile"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteFlow"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteForm"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteLink"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAddon"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeExperience"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteOptimizeIntegrations"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeVariation"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeVariationState"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "manageTemplates" }
          | { type: "String"; id: "read" }
        ),
        { type: "SitePageSettings"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteProfile"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteRedirects"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteSecret"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteSnapshot"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteTrackingSettings"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "manageGroups" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readGroups" }
        ),
        { type: "SiteUserSystems"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteVariable"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteWebhook"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceAsset"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceBilling"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "WorkspaceLibrary"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "takeExam" }
        ),
        { type: "WorkspacePartnerProgram"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceSiteRoles"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteActivityLog"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteClient"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "SiteMembership"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteOptimizeResults"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteReport"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspaceAuditLog"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspaceClient"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceFolder"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerCommissions"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerResourceGroup"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerResources"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "update" },
        { type: "WorkspacePartnerTermsOfService"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "update" },
        { type: "WorkspaceProfile"; id: string },
      ]
    | [
        "allow",
        { type: "User"; id: string },
        { type: "String"; id: "use" },
        { type: "SiteAI"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "AdCreative"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "Admin"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "AdminBlockedEmails"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "OptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "OptimizeNonHostedSiteApp"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "OptimizeNonHostedSiteData"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAI"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteActivityLog"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAeoAnalytics"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAeoBrand"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAeoLLMConfig"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAeoRecommendations"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAgentInstructions"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAgenticWorkflows"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAnalyzeAddon"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteAnnotation"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteApiClientToken"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteApp"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteBilling"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteBranch"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteBranchScope"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCampaign"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteClient"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCollection"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCollectionItem"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCommerce"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCommerceDrivers"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCommerceItem"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCosmic"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCustomCode"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteCustomDomain"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteDesignerModes"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteFile"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteFlow"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteForm"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteLibrary"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteLink"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteMembership"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteMeta"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeAddon"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeExperience"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeIntegrations"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeResults"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeVariation"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteOptimizeVariationState"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePageSettings"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteProfile"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteRedirects"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteReport"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteRole"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteSearch"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteSecret"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteSnapshot"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteStyleBlock"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteSymbol"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteTrackingSettings"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteUserSystems"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteVariable"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SiteWebhook"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "User"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "Workspace"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceApp"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceAsset"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceAuditLog"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceBilling"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceClient"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceFolder"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceIntegration"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceInvite"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceLibrary"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceMembership"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspacePartnerCommissions"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspacePartnerProgram"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspacePartnerResourceGroup"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspacePartnerResources"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspacePartnerTermsOfService"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceProfile"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceSite"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceSiteRoles"; id: string },
      ]
    | [
        "has_locale_access",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "WorkspaceToken"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "accessAPI" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteMeta"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "addComponent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "share" }
        ),
        { type: "SiteLibrary"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "approve" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "design" }
          | { type: "String"; id: "duplicate" }
          | { type: "String"; id: "export" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "share" }
          | { type: "String"; id: "simulateRoles" }
          | { type: "String"; id: "subPublish" }
          | { type: "String"; id: "transfer" }
          | { type: "String"; id: "update" }
        ),
        { type: "Site"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "build" }
          | { type: "String"; id: "create" }
          | { type: "String"; id: "createBranch" }
          | { type: "String"; id: "createFromTemplate" }
          | { type: "String"; id: "duplicate" }
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "editContentInBranch" }
          | { type: "String"; id: "manageTemplates" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "sppPublishToProduction" }
          | { type: "String"; id: "sppPublishToStaging" }
        ),
        { type: "SitePage"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "create" },
        { type: "SiteApiClientToken"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "modifyOwn" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteStyleBlock"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "modify" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteSymbol"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "createReviewer" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceInvite"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "manageMembership" }
          | { type: "String"; id: "moderateComments" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readAccessible" }
          | { type: "String"; id: "readCredited" }
          | { type: "String"; id: "readPermissions" }
          | { type: "String"; id: "readRequiresExplicitAccess" }
          | { type: "String"; id: "restrictAccess" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceSite"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create" }
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceToken"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "createFromTemplate" }
          | { type: "String"; id: "createStandalone" }
          | { type: "String"; id: "design" }
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "merge" }
          | { type: "String"; id: "mergeApproved" }
          | { type: "String"; id: "publish" }
        ),
        { type: "SiteBranch"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "create_items" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCollection"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "Admin"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "OptimizeNonHostedSiteData"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "delete" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readTemplates" }
          | { type: "String"; id: "signUpload" }
          | { type: "String"; id: "update" }
        ),
        { type: "Workspace"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "deleteOwn" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceMembership"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "design" }
          | { type: "String"; id: "edit" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteDesignerModes"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "editContent" }
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteLocale"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "index" },
        { type: "SiteSearch"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "install" }
          | { type: "String"; id: "manage" }
        ),
        { type: "SiteApp"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "install" },
        { type: "WorkspaceApp"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "install" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceIntegration"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "AdCreative"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "AdminBlockedEmails"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "OptimizeNonHostedSiteApp"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoAnalytics"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoBrand"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "view" }
        ),
        { type: "SiteAeoLLMConfig"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAeoRecommendations"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAgentInstructions"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAgenticWorkflows"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteAnalyzeAddon"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteAnnotation"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteBilling"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCampaign"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "queue" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCollectionItem"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerce"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerceDrivers"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "publish" }
          | { type: "String"; id: "queue" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCommerceItem"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCosmic"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCustomCode"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteCustomDomain"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteFile"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteFlow"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteForm"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteLink"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAddon"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeExperience"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteOptimizeIntegrations"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeVariation"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteOptimizeVariationState"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "manageTemplates" }
          | { type: "String"; id: "read" }
        ),
        { type: "SitePageSettings"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteProfile"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteRedirects"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteSecret"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteSnapshot"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "SiteTrackingSettings"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "manageGroups" }
          | { type: "String"; id: "read" }
          | { type: "String"; id: "readGroups" }
        ),
        { type: "SiteUserSystems"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteVariable"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "SiteWebhook"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceAsset"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceBilling"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "manage" },
        { type: "WorkspaceLibrary"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "takeExam" }
        ),
        { type: "WorkspacePartnerProgram"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "manage" }
          | { type: "String"; id: "read" }
        ),
        { type: "WorkspaceSiteRoles"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteActivityLog"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteClient"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "SiteMembership"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteOptimizeResults"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "SiteReport"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspaceAuditLog"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspaceClient"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        (
          | { type: "String"; id: "read" }
          | { type: "String"; id: "update" }
        ),
        { type: "WorkspaceFolder"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerCommissions"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerResourceGroup"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "read" },
        { type: "WorkspacePartnerResources"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "update" },
        { type: "WorkspacePartnerTermsOfService"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "update" },
        { type: "WorkspaceProfile"; id: string },
      ]
    | [
        "has_permission",
        { type: "User"; id: string },
        { type: "String"; id: "use" },
        { type: "SiteAI"; id: string },
      ]
    | [
        "has_site_role",
        { type: "User"; id: string },
        { type: "SiteRole"; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "has_site_role",
        { type: "User"; id: string },
        { type: "String"; id: string },
        { type: "Site"; id: string },
      ]
    | [
        "has_valid_scope",
        { type: "SiteBranch"; id: string },
      ]
    | [
        "is_not_empty_string",
        { type: "String"; id: string },
      ]
    | [
        "is_page_restricted",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "SitePage"; id: string },
      ]
    | [
        "permission_override_allowed",
        { type: "User"; id: string },
        { type: "Site"; id: string },
        { type: "String"; id: string },
        { type: "String"; id: string },
      ]
    | [
        "typeof",
        { type: "AdCreative"; id: string },
        { type: "String"; id: "AdCreative" },
      ]
    | [
        "typeof",
        { type: "Admin"; id: string },
        { type: "String"; id: "Admin" },
      ]
    | [
        "typeof",
        { type: "AdminBlockedEmails"; id: string },
        { type: "String"; id: "AdminBlockedEmails" },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSite"; id: string },
        { type: "String"; id: "OptimizeNonHostedSite" },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSiteApp"; id: string },
        { type: "String"; id: "OptimizeNonHostedSiteApp" },
      ]
    | [
        "typeof",
        { type: "OptimizeNonHostedSiteData"; id: string },
        { type: "String"; id: "OptimizeNonHostedSiteData" },
      ]
    | [
        "typeof",
        { type: "Site"; id: string },
        { type: "String"; id: "Site" },
      ]
    | [
        "typeof",
        { type: "SiteAI"; id: string },
        { type: "String"; id: "SiteAI" },
      ]
    | [
        "typeof",
        { type: "SiteActivityLog"; id: string },
        { type: "String"; id: "SiteActivityLog" },
      ]
    | [
        "typeof",
        { type: "SiteAeoAnalytics"; id: string },
        { type: "String"; id: "SiteAeoAnalytics" },
      ]
    | [
        "typeof",
        { type: "SiteAeoBrand"; id: string },
        { type: "String"; id: "SiteAeoBrand" },
      ]
    | [
        "typeof",
        { type: "SiteAeoLLMConfig"; id: string },
        { type: "String"; id: "SiteAeoLLMConfig" },
      ]
    | [
        "typeof",
        { type: "SiteAeoRecommendations"; id: string },
        { type: "String"; id: "SiteAeoRecommendations" },
      ]
    | [
        "typeof",
        { type: "SiteAgentInstructions"; id: string },
        { type: "String"; id: "SiteAgentInstructions" },
      ]
    | [
        "typeof",
        { type: "SiteAgenticWorkflows"; id: string },
        { type: "String"; id: "SiteAgenticWorkflows" },
      ]
    | [
        "typeof",
        { type: "SiteAnalyzeAddon"; id: string },
        { type: "String"; id: "SiteAnalyzeAddon" },
      ]
    | [
        "typeof",
        { type: "SiteAnnotation"; id: string },
        { type: "String"; id: "SiteAnnotation" },
      ]
    | [
        "typeof",
        { type: "SiteApiClientToken"; id: string },
        { type: "String"; id: "SiteApiClientToken" },
      ]
    | [
        "typeof",
        { type: "SiteApp"; id: string },
        { type: "String"; id: "SiteApp" },
      ]
    | [
        "typeof",
        { type: "SiteBilling"; id: string },
        { type: "String"; id: "SiteBilling" },
      ]
    | [
        "typeof",
        { type: "SiteBranch"; id: string },
        { type: "String"; id: "SiteBranch" },
      ]
    | [
        "typeof",
        { type: "SiteBranchScope"; id: string },
        { type: "String"; id: "SiteBranchScope" },
      ]
    | [
        "typeof",
        { type: "SiteCampaign"; id: string },
        { type: "String"; id: "SiteCampaign" },
      ]
    | [
        "typeof",
        { type: "SiteClient"; id: string },
        { type: "String"; id: "SiteClient" },
      ]
    | [
        "typeof",
        { type: "SiteCollection"; id: string },
        { type: "String"; id: "SiteCollection" },
      ]
    | [
        "typeof",
        { type: "SiteCollectionItem"; id: string },
        { type: "String"; id: "SiteCollectionItem" },
      ]
    | [
        "typeof",
        { type: "SiteCommerce"; id: string },
        { type: "String"; id: "SiteCommerce" },
      ]
    | [
        "typeof",
        { type: "SiteCommerceDrivers"; id: string },
        { type: "String"; id: "SiteCommerceDrivers" },
      ]
    | [
        "typeof",
        { type: "SiteCommerceItem"; id: string },
        { type: "String"; id: "SiteCommerceItem" },
      ]
    | [
        "typeof",
        { type: "SiteCosmic"; id: string },
        { type: "String"; id: "SiteCosmic" },
      ]
    | [
        "typeof",
        { type: "SiteCustomCode"; id: string },
        { type: "String"; id: "SiteCustomCode" },
      ]
    | [
        "typeof",
        { type: "SiteCustomDomain"; id: string },
        { type: "String"; id: "SiteCustomDomain" },
      ]
    | [
        "typeof",
        { type: "SiteDesignerModes"; id: string },
        { type: "String"; id: "SiteDesignerModes" },
      ]
    | [
        "typeof",
        { type: "SiteFile"; id: string },
        { type: "String"; id: "SiteFile" },
      ]
    | [
        "typeof",
        { type: "SiteFlow"; id: string },
        { type: "String"; id: "SiteFlow" },
      ]
    | [
        "typeof",
        { type: "SiteForm"; id: string },
        { type: "String"; id: "SiteForm" },
      ]
    | [
        "typeof",
        { type: "SiteLibrary"; id: string },
        { type: "String"; id: "SiteLibrary" },
      ]
    | [
        "typeof",
        { type: "SiteLink"; id: string },
        { type: "String"; id: "SiteLink" },
      ]
    | [
        "typeof",
        { type: "SiteLocale"; id: string },
        { type: "String"; id: "SiteLocale" },
      ]
    | [
        "typeof",
        { type: "SiteMembership"; id: string },
        { type: "String"; id: "SiteMembership" },
      ]
    | [
        "typeof",
        { type: "SiteMeta"; id: string },
        { type: "String"; id: "SiteMeta" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAddon"; id: string },
        { type: "String"; id: "SiteOptimizeAddon" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAnalyzeMetricEvent"; id: string },
        { type: "String"; id: "SiteOptimizeAnalyzeMetricEvent" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeAudienceEventMetric"; id: string },
        { type: "String"; id: "SiteOptimizeAudienceEventMetric" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeExperience"; id: string },
        { type: "String"; id: "SiteOptimizeExperience" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeIntegrations"; id: string },
        { type: "String"; id: "SiteOptimizeIntegrations" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeResults"; id: string },
        { type: "String"; id: "SiteOptimizeResults" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariation"; id: string },
        { type: "String"; id: "SiteOptimizeVariation" },
      ]
    | [
        "typeof",
        { type: "SiteOptimizeVariationState"; id: string },
        { type: "String"; id: "SiteOptimizeVariationState" },
      ]
    | [
        "typeof",
        { type: "SitePage"; id: string },
        { type: "String"; id: "SitePage" },
      ]
    | [
        "typeof",
        { type: "SitePageSettings"; id: string },
        { type: "String"; id: "SitePageSettings" },
      ]
    | [
        "typeof",
        { type: "SiteProfile"; id: string },
        { type: "String"; id: "SiteProfile" },
      ]
    | [
        "typeof",
        { type: "SiteRedirects"; id: string },
        { type: "String"; id: "SiteRedirects" },
      ]
    | [
        "typeof",
        { type: "SiteReport"; id: string },
        { type: "String"; id: "SiteReport" },
      ]
    | [
        "typeof",
        { type: "SiteSearch"; id: string },
        { type: "String"; id: "SiteSearch" },
      ]
    | [
        "typeof",
        { type: "SiteSecret"; id: string },
        { type: "String"; id: "SiteSecret" },
      ]
    | [
        "typeof",
        { type: "SiteSnapshot"; id: string },
        { type: "String"; id: "SiteSnapshot" },
      ]
    | [
        "typeof",
        { type: "SiteStyleBlock"; id: string },
        { type: "String"; id: "SiteStyleBlock" },
      ]
    | [
        "typeof",
        { type: "SiteSymbol"; id: string },
        { type: "String"; id: "SiteSymbol" },
      ]
    | [
        "typeof",
        { type: "SiteTrackingSettings"; id: string },
        { type: "String"; id: "SiteTrackingSettings" },
      ]
    | [
        "typeof",
        { type: "SiteUserSystems"; id: string },
        { type: "String"; id: "SiteUserSystems" },
      ]
    | [
        "typeof",
        { type: "SiteVariable"; id: string },
        { type: "String"; id: "SiteVariable" },
      ]
    | [
        "typeof",
        { type: "SiteWebhook"; id: string },
        { type: "String"; id: "SiteWebhook" },
      ]
    | [
        "typeof",
        { type: "User"; id: string },
        { type: "String"; id: "User" },
      ]
    | [
        "typeof",
        { type: "Workspace"; id: string },
        { type: "String"; id: "Workspace" },
      ]
    | [
        "typeof",
        { type: "WorkspaceApp"; id: string },
        { type: "String"; id: "WorkspaceApp" },
      ]
    | [
        "typeof",
        { type: "WorkspaceAsset"; id: string },
        { type: "String"; id: "WorkspaceAsset" },
      ]
    | [
        "typeof",
        { type: "WorkspaceAuditLog"; id: string },
        { type: "String"; id: "WorkspaceAuditLog" },
      ]
    | [
        "typeof",
        { type: "WorkspaceBilling"; id: string },
        { type: "String"; id: "WorkspaceBilling" },
      ]
    | [
        "typeof",
        { type: "WorkspaceClient"; id: string },
        { type: "String"; id: "WorkspaceClient" },
      ]
    | [
        "typeof",
        { type: "WorkspaceFolder"; id: string },
        { type: "String"; id: "WorkspaceFolder" },
      ]
    | [
        "typeof",
        { type: "WorkspaceIntegration"; id: string },
        { type: "String"; id: "WorkspaceIntegration" },
      ]
    | [
        "typeof",
        { type: "WorkspaceInvite"; id: string },
        { type: "String"; id: "WorkspaceInvite" },
      ]
    | [
        "typeof",
        { type: "WorkspaceLibrary"; id: string },
        { type: "String"; id: "WorkspaceLibrary" },
      ]
    | [
        "typeof",
        { type: "WorkspaceMembership"; id: string },
        { type: "String"; id: "WorkspaceMembership" },
      ]
    | [
        "typeof",
        { type: "WorkspaceOptimizeNonHostedSite"; id: string },
        { type: "String"; id: "WorkspaceOptimizeNonHostedSite" },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerCommissions"; id: string },
        { type: "String"; id: "WorkspacePartnerCommissions" },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerProgram"; id: string },
        { type: "String"; id: "WorkspacePartnerProgram" },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerResourceGroup"; id: string },
        { type: "String"; id: "WorkspacePartnerResourceGroup" },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerResources"; id: string },
        { type: "String"; id: "WorkspacePartnerResources" },
      ]
    | [
        "typeof",
        { type: "WorkspacePartnerTermsOfService"; id: string },
        { type: "String"; id: "WorkspacePartnerTermsOfService" },
      ]
    | [
        "typeof",
        { type: "WorkspaceProfile"; id: string },
        { type: "String"; id: "WorkspaceProfile" },
      ]
    | [
        "typeof",
        { type: "WorkspaceSite"; id: string },
        { type: "String"; id: "WorkspaceSite" },
      ]
    | [
        "typeof",
        { type: "WorkspaceSiteRoles"; id: string },
        { type: "String"; id: "WorkspaceSiteRoles" },
      ]
    | [
        "typeof",
        { type: "WorkspaceToken"; id: string },
        { type: "String"; id: "WorkspaceToken" },
      ];
  resources: {
    "AdCreative": {
      roles: (typeof PolarResources)["AdCreative"]["roles"][number];
      permissions: (typeof PolarResources)["AdCreative"]["permissions"][number];
      relations: keyof (typeof PolarResources)["AdCreative"]["relations"];
    };
    "Admin": {
      roles: (typeof PolarResources)["Admin"]["roles"][number];
      permissions: (typeof PolarResources)["Admin"]["permissions"][number];
      relations: keyof (typeof PolarResources)["Admin"]["relations"];
    };
    "AdminBlockedEmails": {
      roles: (typeof PolarResources)["AdminBlockedEmails"]["roles"][number];
      permissions: (typeof PolarResources)["AdminBlockedEmails"]["permissions"][number];
      relations: keyof (typeof PolarResources)["AdminBlockedEmails"]["relations"];
    };
    "OptimizeNonHostedSite": {
      roles: (typeof PolarResources)["OptimizeNonHostedSite"]["roles"][number];
      permissions: (typeof PolarResources)["OptimizeNonHostedSite"]["permissions"][number];
      relations: keyof (typeof PolarResources)["OptimizeNonHostedSite"]["relations"];
    };
    "OptimizeNonHostedSiteApp": {
      roles: (typeof PolarResources)["OptimizeNonHostedSiteApp"]["roles"][number];
      permissions: (typeof PolarResources)["OptimizeNonHostedSiteApp"]["permissions"][number];
      relations: keyof (typeof PolarResources)["OptimizeNonHostedSiteApp"]["relations"];
    };
    "OptimizeNonHostedSiteData": {
      roles: (typeof PolarResources)["OptimizeNonHostedSiteData"]["roles"][number];
      permissions: (typeof PolarResources)["OptimizeNonHostedSiteData"]["permissions"][number];
      relations: keyof (typeof PolarResources)["OptimizeNonHostedSiteData"]["relations"];
    };
    "Site": {
      roles: (typeof PolarResources)["Site"]["roles"][number];
      permissions: (typeof PolarResources)["Site"]["permissions"][number];
      relations: keyof (typeof PolarResources)["Site"]["relations"];
    };
    "SiteAI": {
      roles: (typeof PolarResources)["SiteAI"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAI"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAI"]["relations"];
    };
    "SiteActivityLog": {
      roles: (typeof PolarResources)["SiteActivityLog"]["roles"][number];
      permissions: (typeof PolarResources)["SiteActivityLog"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteActivityLog"]["relations"];
    };
    "SiteAeoAnalytics": {
      roles: (typeof PolarResources)["SiteAeoAnalytics"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAeoAnalytics"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAeoAnalytics"]["relations"];
    };
    "SiteAeoBrand": {
      roles: (typeof PolarResources)["SiteAeoBrand"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAeoBrand"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAeoBrand"]["relations"];
    };
    "SiteAeoLLMConfig": {
      roles: (typeof PolarResources)["SiteAeoLLMConfig"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAeoLLMConfig"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAeoLLMConfig"]["relations"];
    };
    "SiteAeoRecommendations": {
      roles: (typeof PolarResources)["SiteAeoRecommendations"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAeoRecommendations"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAeoRecommendations"]["relations"];
    };
    "SiteAgentInstructions": {
      roles: (typeof PolarResources)["SiteAgentInstructions"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAgentInstructions"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAgentInstructions"]["relations"];
    };
    "SiteAgenticWorkflows": {
      roles: (typeof PolarResources)["SiteAgenticWorkflows"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAgenticWorkflows"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAgenticWorkflows"]["relations"];
    };
    "SiteAnalyzeAddon": {
      roles: (typeof PolarResources)["SiteAnalyzeAddon"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAnalyzeAddon"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAnalyzeAddon"]["relations"];
    };
    "SiteAnnotation": {
      roles: (typeof PolarResources)["SiteAnnotation"]["roles"][number];
      permissions: (typeof PolarResources)["SiteAnnotation"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteAnnotation"]["relations"];
    };
    "SiteApiClientToken": {
      roles: (typeof PolarResources)["SiteApiClientToken"]["roles"][number];
      permissions: (typeof PolarResources)["SiteApiClientToken"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteApiClientToken"]["relations"];
    };
    "SiteApp": {
      roles: (typeof PolarResources)["SiteApp"]["roles"][number];
      permissions: (typeof PolarResources)["SiteApp"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteApp"]["relations"];
    };
    "SiteBilling": {
      roles: (typeof PolarResources)["SiteBilling"]["roles"][number];
      permissions: (typeof PolarResources)["SiteBilling"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteBilling"]["relations"];
    };
    "SiteBranch": {
      roles: (typeof PolarResources)["SiteBranch"]["roles"][number];
      permissions: (typeof PolarResources)["SiteBranch"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteBranch"]["relations"];
    };
    "SiteBranchScope": {
      roles: (typeof PolarResources)["SiteBranchScope"]["roles"][number];
      permissions: (typeof PolarResources)["SiteBranchScope"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteBranchScope"]["relations"];
    };
    "SiteCampaign": {
      roles: (typeof PolarResources)["SiteCampaign"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCampaign"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCampaign"]["relations"];
    };
    "SiteClient": {
      roles: (typeof PolarResources)["SiteClient"]["roles"][number];
      permissions: (typeof PolarResources)["SiteClient"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteClient"]["relations"];
    };
    "SiteCollection": {
      roles: (typeof PolarResources)["SiteCollection"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCollection"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCollection"]["relations"];
    };
    "SiteCollectionItem": {
      roles: (typeof PolarResources)["SiteCollectionItem"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCollectionItem"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCollectionItem"]["relations"];
    };
    "SiteCommerce": {
      roles: (typeof PolarResources)["SiteCommerce"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCommerce"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCommerce"]["relations"];
    };
    "SiteCommerceDrivers": {
      roles: (typeof PolarResources)["SiteCommerceDrivers"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCommerceDrivers"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCommerceDrivers"]["relations"];
    };
    "SiteCommerceItem": {
      roles: (typeof PolarResources)["SiteCommerceItem"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCommerceItem"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCommerceItem"]["relations"];
    };
    "SiteCosmic": {
      roles: (typeof PolarResources)["SiteCosmic"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCosmic"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCosmic"]["relations"];
    };
    "SiteCustomCode": {
      roles: (typeof PolarResources)["SiteCustomCode"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCustomCode"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCustomCode"]["relations"];
    };
    "SiteCustomDomain": {
      roles: (typeof PolarResources)["SiteCustomDomain"]["roles"][number];
      permissions: (typeof PolarResources)["SiteCustomDomain"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteCustomDomain"]["relations"];
    };
    "SiteDesignerModes": {
      roles: (typeof PolarResources)["SiteDesignerModes"]["roles"][number];
      permissions: (typeof PolarResources)["SiteDesignerModes"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteDesignerModes"]["relations"];
    };
    "SiteFile": {
      roles: (typeof PolarResources)["SiteFile"]["roles"][number];
      permissions: (typeof PolarResources)["SiteFile"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteFile"]["relations"];
    };
    "SiteFlow": {
      roles: (typeof PolarResources)["SiteFlow"]["roles"][number];
      permissions: (typeof PolarResources)["SiteFlow"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteFlow"]["relations"];
    };
    "SiteForm": {
      roles: (typeof PolarResources)["SiteForm"]["roles"][number];
      permissions: (typeof PolarResources)["SiteForm"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteForm"]["relations"];
    };
    "SiteLibrary": {
      roles: (typeof PolarResources)["SiteLibrary"]["roles"][number];
      permissions: (typeof PolarResources)["SiteLibrary"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteLibrary"]["relations"];
    };
    "SiteLink": {
      roles: (typeof PolarResources)["SiteLink"]["roles"][number];
      permissions: (typeof PolarResources)["SiteLink"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteLink"]["relations"];
    };
    "SiteLocale": {
      roles: (typeof PolarResources)["SiteLocale"]["roles"][number];
      permissions: (typeof PolarResources)["SiteLocale"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteLocale"]["relations"];
    };
    "SiteMembership": {
      roles: (typeof PolarResources)["SiteMembership"]["roles"][number];
      permissions: (typeof PolarResources)["SiteMembership"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteMembership"]["relations"];
    };
    "SiteMeta": {
      roles: (typeof PolarResources)["SiteMeta"]["roles"][number];
      permissions: (typeof PolarResources)["SiteMeta"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteMeta"]["relations"];
    };
    "SiteOptimizeAddon": {
      roles: (typeof PolarResources)["SiteOptimizeAddon"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeAddon"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeAddon"]["relations"];
    };
    "SiteOptimizeAnalyzeMetricEvent": {
      roles: (typeof PolarResources)["SiteOptimizeAnalyzeMetricEvent"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeAnalyzeMetricEvent"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeAnalyzeMetricEvent"]["relations"];
    };
    "SiteOptimizeAudienceEventMetric": {
      roles: (typeof PolarResources)["SiteOptimizeAudienceEventMetric"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeAudienceEventMetric"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeAudienceEventMetric"]["relations"];
    };
    "SiteOptimizeExperience": {
      roles: (typeof PolarResources)["SiteOptimizeExperience"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeExperience"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeExperience"]["relations"];
    };
    "SiteOptimizeIntegrations": {
      roles: (typeof PolarResources)["SiteOptimizeIntegrations"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeIntegrations"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeIntegrations"]["relations"];
    };
    "SiteOptimizeResults": {
      roles: (typeof PolarResources)["SiteOptimizeResults"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeResults"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeResults"]["relations"];
    };
    "SiteOptimizeVariation": {
      roles: (typeof PolarResources)["SiteOptimizeVariation"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeVariation"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeVariation"]["relations"];
    };
    "SiteOptimizeVariationState": {
      roles: (typeof PolarResources)["SiteOptimizeVariationState"]["roles"][number];
      permissions: (typeof PolarResources)["SiteOptimizeVariationState"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteOptimizeVariationState"]["relations"];
    };
    "SitePage": {
      roles: (typeof PolarResources)["SitePage"]["roles"][number];
      permissions: (typeof PolarResources)["SitePage"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SitePage"]["relations"];
    };
    "SitePageSettings": {
      roles: (typeof PolarResources)["SitePageSettings"]["roles"][number];
      permissions: (typeof PolarResources)["SitePageSettings"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SitePageSettings"]["relations"];
    };
    "SiteProfile": {
      roles: (typeof PolarResources)["SiteProfile"]["roles"][number];
      permissions: (typeof PolarResources)["SiteProfile"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteProfile"]["relations"];
    };
    "SiteRedirects": {
      roles: (typeof PolarResources)["SiteRedirects"]["roles"][number];
      permissions: (typeof PolarResources)["SiteRedirects"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteRedirects"]["relations"];
    };
    "SiteReport": {
      roles: (typeof PolarResources)["SiteReport"]["roles"][number];
      permissions: (typeof PolarResources)["SiteReport"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteReport"]["relations"];
    };
    "SiteRole": {
      roles: (typeof PolarResources)["SiteRole"]["roles"][number];
      permissions: (typeof PolarResources)["SiteRole"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteRole"]["relations"];
    };
    "SiteSearch": {
      roles: (typeof PolarResources)["SiteSearch"]["roles"][number];
      permissions: (typeof PolarResources)["SiteSearch"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteSearch"]["relations"];
    };
    "SiteSecret": {
      roles: (typeof PolarResources)["SiteSecret"]["roles"][number];
      permissions: (typeof PolarResources)["SiteSecret"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteSecret"]["relations"];
    };
    "SiteSnapshot": {
      roles: (typeof PolarResources)["SiteSnapshot"]["roles"][number];
      permissions: (typeof PolarResources)["SiteSnapshot"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteSnapshot"]["relations"];
    };
    "SiteStyleBlock": {
      roles: (typeof PolarResources)["SiteStyleBlock"]["roles"][number];
      permissions: (typeof PolarResources)["SiteStyleBlock"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteStyleBlock"]["relations"];
    };
    "SiteSymbol": {
      roles: (typeof PolarResources)["SiteSymbol"]["roles"][number];
      permissions: (typeof PolarResources)["SiteSymbol"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteSymbol"]["relations"];
    };
    "SiteTrackingSettings": {
      roles: (typeof PolarResources)["SiteTrackingSettings"]["roles"][number];
      permissions: (typeof PolarResources)["SiteTrackingSettings"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteTrackingSettings"]["relations"];
    };
    "SiteUserSystems": {
      roles: (typeof PolarResources)["SiteUserSystems"]["roles"][number];
      permissions: (typeof PolarResources)["SiteUserSystems"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteUserSystems"]["relations"];
    };
    "SiteVariable": {
      roles: (typeof PolarResources)["SiteVariable"]["roles"][number];
      permissions: (typeof PolarResources)["SiteVariable"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteVariable"]["relations"];
    };
    "SiteWebhook": {
      roles: (typeof PolarResources)["SiteWebhook"]["roles"][number];
      permissions: (typeof PolarResources)["SiteWebhook"]["permissions"][number];
      relations: keyof (typeof PolarResources)["SiteWebhook"]["relations"];
    };
    "User": {
      roles: (typeof PolarResources)["User"]["roles"][number];
      permissions: (typeof PolarResources)["User"]["permissions"][number];
      relations: keyof (typeof PolarResources)["User"]["relations"];
    };
    "Workspace": {
      roles: (typeof PolarResources)["Workspace"]["roles"][number];
      permissions: (typeof PolarResources)["Workspace"]["permissions"][number];
      relations: keyof (typeof PolarResources)["Workspace"]["relations"];
    };
    "WorkspaceApp": {
      roles: (typeof PolarResources)["WorkspaceApp"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceApp"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceApp"]["relations"];
    };
    "WorkspaceAsset": {
      roles: (typeof PolarResources)["WorkspaceAsset"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceAsset"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceAsset"]["relations"];
    };
    "WorkspaceAuditLog": {
      roles: (typeof PolarResources)["WorkspaceAuditLog"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceAuditLog"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceAuditLog"]["relations"];
    };
    "WorkspaceBilling": {
      roles: (typeof PolarResources)["WorkspaceBilling"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceBilling"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceBilling"]["relations"];
    };
    "WorkspaceClient": {
      roles: (typeof PolarResources)["WorkspaceClient"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceClient"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceClient"]["relations"];
    };
    "WorkspaceFolder": {
      roles: (typeof PolarResources)["WorkspaceFolder"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceFolder"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceFolder"]["relations"];
    };
    "WorkspaceIntegration": {
      roles: (typeof PolarResources)["WorkspaceIntegration"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceIntegration"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceIntegration"]["relations"];
    };
    "WorkspaceInvite": {
      roles: (typeof PolarResources)["WorkspaceInvite"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceInvite"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceInvite"]["relations"];
    };
    "WorkspaceLibrary": {
      roles: (typeof PolarResources)["WorkspaceLibrary"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceLibrary"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceLibrary"]["relations"];
    };
    "WorkspaceMembership": {
      roles: (typeof PolarResources)["WorkspaceMembership"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceMembership"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceMembership"]["relations"];
    };
    "WorkspaceOptimizeNonHostedSite": {
      roles: (typeof PolarResources)["WorkspaceOptimizeNonHostedSite"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceOptimizeNonHostedSite"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceOptimizeNonHostedSite"]["relations"];
    };
    "WorkspacePartnerCommissions": {
      roles: (typeof PolarResources)["WorkspacePartnerCommissions"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspacePartnerCommissions"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspacePartnerCommissions"]["relations"];
    };
    "WorkspacePartnerProgram": {
      roles: (typeof PolarResources)["WorkspacePartnerProgram"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspacePartnerProgram"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspacePartnerProgram"]["relations"];
    };
    "WorkspacePartnerResourceGroup": {
      roles: (typeof PolarResources)["WorkspacePartnerResourceGroup"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspacePartnerResourceGroup"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspacePartnerResourceGroup"]["relations"];
    };
    "WorkspacePartnerResources": {
      roles: (typeof PolarResources)["WorkspacePartnerResources"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspacePartnerResources"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspacePartnerResources"]["relations"];
    };
    "WorkspacePartnerTermsOfService": {
      roles: (typeof PolarResources)["WorkspacePartnerTermsOfService"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspacePartnerTermsOfService"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspacePartnerTermsOfService"]["relations"];
    };
    "WorkspaceProfile": {
      roles: (typeof PolarResources)["WorkspaceProfile"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceProfile"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceProfile"]["relations"];
    };
    "WorkspaceSite": {
      roles: (typeof PolarResources)["WorkspaceSite"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceSite"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceSite"]["relations"];
    };
    "WorkspaceSiteRoles": {
      roles: (typeof PolarResources)["WorkspaceSiteRoles"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceSiteRoles"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceSiteRoles"]["relations"];
    };
    "WorkspaceToken": {
      roles: (typeof PolarResources)["WorkspaceToken"]["roles"][number];
      permissions: (typeof PolarResources)["WorkspaceToken"]["permissions"][number];
      relations: keyof (typeof PolarResources)["WorkspaceToken"]["relations"];
    };
  };
};

